import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

import countries from "i18n-iso-countries";
import enCountryLocale from "i18n-iso-countries/langs/en.json";
import deCountryLocale from "i18n-iso-countries/langs/de.json";

countries.registerLocale(enCountryLocale);
countries.registerLocale(deCountryLocale);

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    supportedLngs: ["en", "de"], // ["en", "de", "es"],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
  });

export default i18n;

export const supportedLanguages = {
  en: "English",
  de: "Deutsch"
  // ,es: "Español"
};